import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import { state as breadcrumbsState } from 'atoms/breadcrumbs';
import { state as contentTypeState } from 'atoms/content-type';
import { state as navigationContentState } from 'atoms/navigation-content';
import { state as toolsState } from 'atoms/tools';
import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { routes } from '../../constants';

const EventLobbyContainer = () => {
    const setContentType = useSetRecoilState(contentTypeState);
    const setBreadcrumbs = useSetRecoilState(breadcrumbsState);
    const setTools = useSetRecoilState(toolsState);
    const setNavigationContent = useSetRecoilState(navigationContentState);

    useEffect(() => {
        setBreadcrumbs([
            {
                text: 'Workshop Studio',
                href: routes.landingPage,
            },
            {
                text: 'Event lobby',
                href: routes.lobby,
            },
        ]);
        setTools({
            open: false,
            hide: true,
            content: <></>,
        });
        setNavigationContent(null);
        setContentType('default');
    }, []);

    return (
        <Container header={<Header variant="h2">Event lobby</Header>}>
            🚧 Coming soon 🚧
        </Container>
    );
};

export default EventLobbyContainer;
